$_vikon('#note_hide_btn').bind('click', () => {
    $_vikon('#note_panel').toggle('fast');
    const arrow = $_vikon('#arrow');
    const theClass = arrow.attr('class');
    if (theClass === 'glyphicon glyphicon-chevron-right') {
        arrow.removeClass('glyphicon-chevron-right');
        arrow.addClass('glyphicon glyphicon-chevron-left');
    } else {
        arrow.removeClass('glyphicon-chevron-left');
        arrow.addClass('glyphicon glyphicon-chevron-right');
    }
});
